import React from 'react';

import { If } from 'utils';
import { UiKit } from 'components';
import { ReactComponent as ViewIcon } from 'assets/img/icons/eye.svg';
import { ReactComponent as EditIcon } from 'assets/img/icons/edit.svg';
import { ReactComponent as DeleteIcon } from 'assets/img/icons/delete-muted.svg';

export default function Actions({
  id = '',
  viewBtnId = '',
  editBtnId = '',
  deleteBtnId = '',
  customClass = '',
  disableViewBtn = false,
  disableEditBtn = false,
  disableDeleteBtn = false,
  view = () => {},
  edit = () => {},
  remove = () => {},
  permissions = { view: false, edit: false, delete: false },
  tooltipMessage = { view: '', edit: '', delete: '' }
}) {
  const elementCount = [
    permissions.view,
    permissions.edit,
    permissions.delete
  ].filter(Boolean).length;

  const onView = () => !disableViewBtn && view(id);
  const onEdit = () => !disableEditBtn && edit(id);
  const onDelete = () => !disableDeleteBtn && remove(id);

  if (!elementCount) return null;

  return (
    <UiKit.Grid
      gap="8"
      templateColumns={`repeat(${elementCount}, auto)`}
      className="justify-content-end"
    >
      <If test={permissions.view}>
        <UiKit.Tooltip disabled={!tooltipMessage.view}>
          <UiKit.Tooltip.Trigger>
            <UiKit.Button
              size="sm"
              variant="outline"
              onClick={onView}
              disabled={disableViewBtn}
              className="p-0"
            >
              <ViewIcon width="14" height="14" />
            </UiKit.Button>
          </UiKit.Tooltip.Trigger>
          <UiKit.Tooltip.Content>{tooltipMessage.view}</UiKit.Tooltip.Content>
        </UiKit.Tooltip>
      </If>

      <If test={permissions.edit}>
        <UiKit.Tooltip disabled={!tooltipMessage.edit}>
          <UiKit.Tooltip.Trigger>
            <UiKit.Button
              size="sm"
              variant="outline"
              onClick={onEdit}
              disabled={disableEditBtn}
              className="p-0"
            >
              <EditIcon width="14" height="14" />
            </UiKit.Button>
          </UiKit.Tooltip.Trigger>
          <UiKit.Tooltip.Content>{tooltipMessage.edit}</UiKit.Tooltip.Content>
        </UiKit.Tooltip>
      </If>

      <If test={permissions.delete}>
        <UiKit.Tooltip disabled={!tooltipMessage.delete}>
          <UiKit.Tooltip.Trigger>
            <UiKit.Button
              size="sm"
              variant="outline"
              onClick={onDelete}
              disabled={disableDeleteBtn}
              className="p-0"
            >
              <DeleteIcon width="14" height="14" />
            </UiKit.Button>
          </UiKit.Tooltip.Trigger>
          <UiKit.Tooltip.Content>{tooltipMessage.delete}</UiKit.Tooltip.Content>
        </UiKit.Tooltip>
      </If>
    </UiKit.Grid>
  );
}
